<template>
    <b-card :style="{'max-width': get_max_width(), 'width': '90%', 'margin-left': 'auto', 'margin-right': 'auto', 'margin-top': '10px'}">
        <b-card-text>Open Requests</b-card-text>

        <b-overlay :show="items_being_loaded" rounded="md">
            <div v-if="items.length > 0">
                <b-card-text v-if="selected.length > 0">
                    <b-button size="sm" variant="outline-primary" @click="update_selected">Update Selected</b-button>
                </b-card-text>

                <table style="width: 100%; border-collapse: separate; border-spacing: 0px 15px;">
                    <thead>
                        <tr style="background: black; color: white;">
                            <td class="ipt_tdhr">
                                #
                            </td>
                            <td class="ipt_tdhr">
                                CREATED
                            </td>
                            <td class="ipt_tdhr">
                                NEED ON
                            </td>
                            <td class="ipt_tdhr">
                                INV/TR
                            </td>
                            <td class="ipt_tdhr">
                                ITEMS
                            </td>
                            <td class="ipt_tdhr">
                                STATUS
                            </td>
                            <td class="ipt_tdhr">
                                ACTION
                            </td>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="item, idx in items" :style="{background: get_background(item)}" v-bind:key="idx">
                            <td class="ipt_tdr">
                                {{ idx + 1 }}
                            </td>
                            <td class="ipt_tdr">
                                {{ item.created_date }}
                            </td>
                            <td class="ipt_tdr">
                                {{ item.request_date }}
                            </td>
                            <td class="ipt_tdr">
                                {{ item.invoice_id }}
                            </td>
                            <td class="ipt_tdr" style="padding: 0px; border: 0px;">
                                <table style="width: 100%; margin: 0px;">
                                <tr v-for="element,eidx in item.items" v-bind:key="eidx">
                                    <td class="ipt_tdr" style="width: 200px;">
                                        {{element.product_sku}}
                                    </td>
                                    <td class="ipt_tdr" style="width: 40px;">
                                        x {{element.quantity}}
                                    </td>
                                    <td class="ipt_tdr">
                                        <b-form-select 
                                            size="sm" 
                                            style="width: 160px; font-size: 12px;"
                                            v-model="element.locsub"
                                            :disabled="packet.userDetails.userrole != 'admin'"
                                        >
                                            <b-form-select-option v-for="locsub, locidx in packet.locsubs" :value="locsub.value" v-bind:key="locidx">
                                                
                                                {{ all_loc_inventory_dict[
                                                    JSON.stringify(element.product_id)
                                                    +
                                                    element.product_sku
                                                    +
                                                    JSON.stringify(locsub.location_id)
                                                    +
                                                    JSON.stringify(locsub.sublocation_id)
                                                ]}} 

                                                - 

                                                {{ locsub.location }} | {{ locsub.sublocation }} 
                                            </b-form-select-option>
                                        </b-form-select>
                                    </td>
                                </tr>
                                </table>
                            </td>
                            <td class="ipt_tdr">
                                <b-form-select 
                                    style="width: 120px;"
                                    size="sm" 
                                    v-model="item.status"
                                    
                                    :disabled="( ['admin', 'locationadmin'].indexOf(packet.userDetails.userrole) > 0 || item.status > 2 )"
                                >
                                    <b-form-select-option v-for="st,stidx in global_vars.TRANSFER_STATUSES" :disabled="st.value > 2 || st.value == null" :value="st.value" v-bind:key="stidx">{{st.text}}</b-form-select-option>
                                </b-form-select>
                            </td>
                            <td class="ipt_tdr">
                                <b-button variant="outline-dark" @click="update(item)">Update</b-button>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
            <div v-else>
                <b-card-text>
                    <b-alert variant="warning" show>No Open Requests</b-alert>
                </b-card-text>
            </div>
        </b-overlay>

    </b-card>
</template>

<script>
    import moment from 'moment'
    import global_vars from '@/utilities/global_vars'
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'
   
    export default {
        name: "AdminToolsOpenRequests",
        props: [],
        components: {Backer},
        data: function(){
            return {
                items: [],
                items_being_loaded: false,
                packet: {},
                all_loc_inventory_dict: {},
                global_vars: global_vars,
                selected: []
            }
        },
        methods: {
            fetch_init: function(){
                let that = this;
                let data = {};
                let path = "/api/transfers/get_open_transfers/"
                let s = function(response){
                    if (response.data.result){
                        that.items = response.data.result;
                        that.items = that.items.map(function(d){
                            d.items = d.items.map(function(e){
                                if (e.source_location_id != null){
                                    e.locsub = e.source_location_id +'|'+e.source_sublocation_id
                                }
                                else {
                                    e.locsub = null;
                                }
                                
                                return e
                            })
                            return d
                        })
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false;
                }
                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "Error loading inventory.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.items_being_loaded = false;
                }
                this.items_being_loaded = true;
                Requestor.getSyncP(path, data, this, s, f);
            },
            fetch_prereqs: function(){
                let that = this;
                let prereqs = [
                    {
                        path:  "/api/inventory/get_all_loc_inventory_dict/",
                        data: {},
                        type: "",
                        executable: Requestor.getAsync,
                        s: function(response){
                            if (response.data.result){
                                that.all_loc_inventory_dict = response.data.result;
                                that.fetch_init()
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            console.log(error)
                            that.$bvToast.toast(
                                "Error loading inventory.",
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                ]

                for (var i=0; i<prereqs.length; i++){
                    let path = prereqs[i]["path"];
                    let data = prereqs[i]["data"];
                    let s = prereqs[i]["s"];
                    let f = prereqs[i]["f"];
                    let type = prereqs[i]["type"];
                    if (type == "secure"){
                        prereqs[i]["executable"](path, data, this, s, f);   
                    }
                    else {
                        prereqs[i]["executable"](path, data, s, f); 
                    }
                }
            },
            update: function(item){
                let status = item.status;
                let locsubs = item.items.map(function(d){return d.locsub})
                if (status == 1 && locsubs.indexOf(null) >= 0){
                    this.$vex.dialog.alert({
                        message: "Cannot approve an order without assigning all fulfilling locations."
                    });
                    return
                }

                item.items = item.items.map(function(d){
                    let locsub = d.locsub;
                    if (locsub){
                        let splitted = locsub.split("|");
                        d.source_location_id = +splitted[0];
                        d.source_sublocation_id = +splitted[1];
                    }
                    
                    return d;
                });
                item.stage_for = null;

                let path = "/api/transfers/update/"
                let that = this;
                let data = item;

                let s = function(response){
                    if (response.data.result){
                        that.$bvToast.toast(
                            "Updated.", 
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                }
                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "Error updating transfer. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                }
                
                Requestor.postAsyncP(path, data, this, s, f);
            },
            compose_update: function(item){
                let approved_quantity = parseInt(item.approved_quantity);
                let status = item.status;
                let locsub = item.locsub;
                let source_location_id = null;
                let source_sublocation_id = null;
                if (locsub){
                    source_location_id = parseInt(locsub.split("|")[0])
                    source_sublocation_id = parseInt(locsub.split("|")[1])
                }

                let output = {out: {}, error: null};
                if (isNaN(approved_quantity)){
                    output.error = "Please specify a valid approved quantity."
                }
                output.out = {status: status, source_location_id: source_location_id, source_sublocation_id: source_sublocation_id, approved_quantity: approved_quantity, tr_id: item.tr_id, itemid: item.itemid}
                return output;
            },
            update_single_item: function(item){
                let update_item = this.compose_update(item);
                //any error
                if (update_item.error){
                    this.$vex.dialog.alert({
                        message: update_item.error
                    }); 
                    return
                }
                let data = {items: [update_item.out]}
                this.update(data)
            },

            select_all_items: function(checked){
                if (checked == true){
                    for (var i = 0; i<this.items.length; i++){
                        this.selected.push(
                            this.items[i].tr_id + '|' + this.items[i].itemid
                        )
                    }
                }
                else {
                    this.selected = []
                }
            },
            update_selected: function(e){
                if (e){
                    e.preventDefault();
                }

                if (this.selected.length <= 0){
                    return
                }
                else {
                    let that = this;
                    let selected_items = this.items.filter(function(d){ return that.selected.indexOf(d.tr_id+'|'+d.itemid) >= 0 })

                    if (selected_items.length > 0){
                        let composed = selected_items.map(function(d){ return that.compose_update(d)});
                        //any errors
                        let errors = composed.filter(function(d){ return d.error != null })
                        if (errors.length > 0){
                            this.$vex.dialog.alert({
                                message: errors[0].error
                            }); 
                            return
                        }
                        else {
                            //go and update all
                            this.update({items: composed.map(function(d){return d.out} )})
                        }
                    }
                }
            },
            get_background: function(item){
                if (item.status == 1){
                    return '#d6ffa7'
                }
                else if (item.status == 0) {
                    return 'lightyellow'
                }
                else {
                    return '#d5d5d5'
                }
            },
            get_max_width: function(){
                return '1050px'
            }
        },
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            this.fetch_prereqs()
        }
    }
    
</script>

<style scoped>
    td {
        font-size: 13px;
        background: inherit;
    }
</style>


// WEBPACK FOOTER //
// src/components/AdminTools/AdminToolsOpenRequests.vue